export default {
	default: "admin",

	routes: {
		admin: {
			routes: [
				{title: "משתמשים", name: "users-page", icon: "fas fa-users"},
				{title: "מרכזים", name: "companies-page", icon: "fas fa-user-circle"},
				{title: "משחקים", name: "games-page", icon: "fas fa-gamepad"},

			]
		}
	}
};
